"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitErrorFromLogIfNeeded = exports.submitError = void 0;
const axios_1 = require("axios");
const date_fns_1 = require("date-fns");
const log_utils_1 = require("./log.utils");
const submitError = async ({ sender, config, error, level, context, channelName, }) => {
    if (!config.apiKeys.errorsApiKey) {
        console.warn('Cannot post error. Errors API key is missing');
    }
    axios_1.default
        .post(`${config.errorsApi}/error`, {
        error,
        level,
        sender,
        date: (0, date_fns_1.format)(new Date(), 'yyyy-MM-dd'),
        env: config.stage,
        context: JSON.stringify(context),
        timestamp: Date.now(),
        channelName: channelName || '',
    }, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: config.apiKeys.errorsApiKey,
        },
    })
        .catch((reason) => {
        (0, log_utils_1.logError)(reason);
    });
};
exports.submitError = submitError;
function submitErrorFromLogIfNeeded({ context, severity, payload, customSubmitError, }) {
    if (severity === 'warning' ||
        severity === 'error' ||
        severity === 'critical') {
        const errorText = typeof payload === 'object'
            ? JSON.stringify(payload, null, 2)
            : payload;
        customSubmitError({
            error: errorText,
            level: severity === 'critical'
                ? 'critical'
                : severity === 'error'
                    ? 'normal'
                    : 'minor',
            context,
        });
    }
}
exports.submitErrorFromLogIfNeeded = submitErrorFromLogIfNeeded;
//# sourceMappingURL=errors-submission.js.map